/**
 * @generated SignedSource<<198841e5fe14781032890aac8d5dbcd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "usePartialItems_viewer" | "useSbSharedItemTracking_viewer">;
  readonly " $fragmentType": "BuySharedResultContainer_viewer";
};
export type BuySharedResultContainer_viewer$key = {
  readonly " $data"?: BuySharedResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePartialItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "dc56f7c4ded70ea69e605e2f7dbf4a45";

export default node;
